import { render, staticRenderFns } from "./DashboardFiles.vue?vue&type=template&id=353b0578&scoped=true&"
import script from "./DashboardFiles.vue?vue&type=script&lang=js&"
export * from "./DashboardFiles.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFiles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardFiles.vue?vue&type=style&index=1&id=353b0578&scoped=true&lang=css&"
import style2 from "./DashboardFiles.vue?vue&type=style&index=2&id=353b0578&scoped=true&lang=css&"
import style3 from "./DashboardFiles.vue?vue&type=style&index=3&id=353b0578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b0578",
  null
  
)

export default component.exports